import {
  Box,
  Stack,
  Theme,
  useMediaQuery,
  Chip,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import { Game } from "../../../models/Game";
import { getTeamFromString } from "../../../models/Team";
import {
  useLeagueEnvironment,
  useLeagueLogo,
} from "../../../data/LeagueEnvironmentProvider";

interface Props {
  game: Game;
}

export default function GameDisplay({ game }: Props) {
  const [loc, opp] = game.opponentInfo.split(" ");
  const isHome = loc === "vs";
  const day = dayjs(game.date);
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );
  const environment = useLeagueEnvironment();
  const oppTeam = getTeamFromString(opp, environment);
  const getTeamLogoUrl = useLeagueLogo();

  return (
    <>
      <Box
        className={`game-display--location-indicator ${
          isHome ? "home" : "away"
        }`}
      >
        {isHome ? "Home" : "Away"}
      </Box>
      <Box
        className={"game-display--date-indicator"}
        sx={{
          span: { lineHeight: 1.2 },
        }}
      >
        <span>{day.format("dddd")}</span>
        <span className="bold">{day.format("MMM D")}</span>
        <span className="game-display--year-indicator">
          {day.format("YYYY")}
        </span>
        {game.seasonType === "Preseason" && (
          <Chip
            label="Preseason"
            size="small"
            color="primary"
            variant="filled"
            className="game-display--preseason-chip"
          />
        )}
      </Box>
      {!isMobile && (
        <Box className="game-display--location-connector">{loc}</Box>
      )}
      <Box className="game-display--opponent-indicator">
        <Box
          component="img"
          className="game-display--opponent-logo"
          src={getTeamLogoUrl(oppTeam.nbaId)}
        />
        {!isMobile && (
          <Stack
            alignItems="flex-start"
            sx={{
              ".MuiTypography-root": {
                fontSize: "0.9em",
                lineHeight: 1.2,
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              },
              span: {
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              },
            }}
          >
            <Typography>{oppTeam.city}</Typography>
            <Typography fontWeight={"bold"}>{oppTeam.name}</Typography>
            {game.result && game.score && (
              <Box className="game-display--result-container">
                <span
                  className={`game-display--result ${game.result.toLowerCase()}`}
                >
                  {game.result}
                </span>
                <span className="game-display--score">{game.score}</span>
              </Box>
            )}
          </Stack>
        )}
      </Box>
    </>
  );
}
